export enum OfferTemplateSettingsItemType {
  DEFAULT = 'DEFAULT',
  /** @deprecated */
  CUSTOM_IMAGE = 'CUSTOM_IMAGE',
  /** PDF Overlay for the first page, containing customer branded header & footer. */
  PDF_FIRST_PAGE = 'PDF_FIRST_PAGE',
  /** Image containing a preview for an overlayed Offer PDF of the first page. */
  PDF_FIRST_PAGE_PREVIEW = 'PDF_FIRST_PAGE_PREVIEW',
  /** PDF Overlay for all following pages, containing customer branded header & footer. */
  PDF_FOLLOWING_PAGES = 'PDF_FOLLOWING_PAGES',
  /** Image containing a preview for an overlayed Offer PDF of the second page. */
  PDF_FOLLOWING_PAGES_PREVIEW = 'PDF_FOLLOWING_PAGES_PREVIEW',
}

export enum OfferTemplateSettingsContentType {
  SHORT_DESCRIPTION = 'SHORT_DESCRIPTION',
  LONG_DESCRIPTION = 'LONG_DESCRIPTION'
}

export enum OfferTemplateId {
  CUSTOM = 'custom',
}
